module.exports = __webpack_public_path__ + "media/images/entities_logo/cetesb-a0e694bbf2798fe930038abef978cd51.png";